import React from "react";
import Breadcrumbs from "../../CommonElements/Breadcrumbs";
import BuatBaru from "../../Component/Transaksi/containers/BuatGroupTransaksi";
import { Card, CardBody } from "reactstrap";
import PageContainer from "../../Layout/Containers/PageContainer";

const BuatBaruGroup = () => {
  return (
    <PageContainer
      breadcrumbs={<Breadcrumbs parent="sikeuangan" title="Buat Baru" />}
    >
      <Card>
        <CardBody>
          <BuatBaru />
        </CardBody>
      </Card>
    </PageContainer>
  );
};

export default BuatBaruGroup;
